var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tabs-wrap",style:({ justifyContent: _vm.justifyContent })},_vm._l((_vm.tabList),function(tab,index){return _c('div',{key:'tab' + index,class:{
      active: index === _vm.selectedIndx,
      firstClass: index === 0,
    },on:{"click":function($event){return _vm.selectTab(tab, index)}}},[_vm._v(" "+_vm._s(tab.name)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }